import api from "./api";

const pettyCashService = {
  create: async (data) => {
    const response = await api.post("/pettycash/save", data);
    return response.data;
  },

  getByProject: async (projectId, companyId, page = 1, limit = 20) => {
    const res = await api.get(
      `/pettycash/getByProject/${projectId}/${companyId}`, {
      params: {
        page,
        limit
      },
    });
    return res.data.data;
  },

  getAll: async (companyId, page = 1, limit = 20, search = "") => {
    const res = await api.get(`/pettycash/getAll/${companyId}`, {
      params: { page, limit, search },
    });
    return res.data;
  },

  getActive: async (companyId) => {
    const res = await api.get(`/pettycash/getActive/${companyId}`);
    return res.data.data;
  },

  update: async (id, data) => {
    const response = await api.put(`/pettycash/update/${id}`, data);
    return response.data;
  },

  updateStatus: async (id) => {
    const response = await api.put(`/pettycash/updateStatus/${id}`);
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/pettycash/delete/${id}`);
    return response.data;
  },

  getEmployeeBalance: async (employeeId, companyId) => {
    const res = await api.get(
      `/pettycash/balance/${employeeId}/${companyId}`
    );
    return res.data.data;
  },

  getEmployeesByCompany: async (companyId) => {
    const response = await api.get(`/pettycash/employees/${companyId}`);
    return response.data;
  },

  getByEmployee: async (employeeId, companyId) => {
    const res = await api.get(
      `/pettycash/getByEmployee/${employeeId}/${companyId}`
    );
    return res.data.data;
  },

  getByEmployeeAndProject: async (employeeId, projectId, companyId) => {
    const res = await api.get(
      `/pettycash/byEmployeeAndProject/${employeeId}/${projectId}/${companyId}`
    );
    return res.data.data;
  },

  getPettyCashList: async (payload) => {
    const res = await api.post("/pettycash/list", payload);
    return res.data.data;
  },

  // DATE FILTER SEARCH (VIEW PAGE)
  // DATE FILTER SEARCH (VIEW PAGE)
  searchByDate: async ({ companyId, employeeId, fromDate, toDate, projectId, type, page, limit }) => {
    console.log(companyId, employeeId, fromDate, toDate, projectId);
    const res = await api.get("/pettycash/getSearch", {
      params: {
        companyId,
        employeeId,
        fromDate,
        toDate,
        projectId: projectId || null,
        type,
        page, limit
      },
    });

    return res.data;
  },

  getEmployeesByManager: async (
    companyId,
    employeeId,
    roleId
  ) => {

    const response = await api.get(
      `/pettycash/employeesByManager/${companyId}`,
      {
        params: {
          employeeId,
          roleId
        }
      }
    );

    return response.data;
  },

};

export default pettyCashService;
